import employees from "../services/employees";
import notification from "../services/notification";

const mutations = {
    reset(state) {
        state.loading = false;
        state.error = null;
        state.errors = {};
        state.message = null;
        state.search = null;
        state.view = {};
        state.created = false;
        state.updated = false;
        state.deleted = false;
        state.loading = false;
        state.searchBy = "all";
    },

    getList(state, response) {
        state.list = response.data;
        state.maxPage = response.max_page;
        state.nextPage = response.next_page;
        state.prevPage = response.prev_page;

        state.created = false;
        state.updated = false;
        state.deleted = false;
        state.loading = false;
        state.errors = {};
    },

    setPage(state, page) {
        state.page = page;
    },

    errors(state, errors) {
        state.errors = errors;
        state.loading = false;
    },

    created(state) {
        state.created = true;
    },

    view(state, data) {
        state.view = data;
    },

    updated(state) {
        state.updated = true;
    },

    deleted(state) {
        state.deleted = true;
    },

    setSearch(state, search) {
        state.search = search;
        state.page = 1;
    },

    searchBy(state, key) {
        state.searchBy = key;
    },

    nextPage(state) {
        if (state.nextPage) {
            state.page = state.nextPage;
        }
    },

    prevPage(state) {
        if (state.prevPage) {
            state.page = state.prevPage;
        }
    },

    loading(state, value = true) {
        state.loading = value;
    },

    saving(state, value) {
        state.saving = value;
    },
    error(state, errors) {
        state.error = errors;
    },

    setMmaAutoLogoutSettings(state, data) {
      state.mma_auto_logout_settings = data;
    },
    
    pagination(state, pagination) {
        state.pagination.totalPerPage = pagination.data.length;
        state.pagination.maxPage =
            state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
        state.pagination.prevPage = pagination.prev_page;
        state.pagination.nextPage = pagination.next_page;
        state.pagination.currentPage = state.pagination.prevPage + 1;
        state.pagination.currentFirstItem =
            state.pagination.totalPerPage > 0
                ? state.pagination.initialPageCount *
                        state.pagination.prevPage +
                    1
                : 0;
        state.pagination.currentLastItem =
            state.pagination.currentFirstItem > 0
                ? state.pagination.currentFirstItem +
                    state.pagination.totalPerPage -
                    1
                : 0;
    },

    setInitialPageCount(state, list) {
        state.pagination.initialPageCount = list.length;
    },
};

const actions = {
    getList: async ({ commit, state }, page = 1) => {
        try {
            let response = await employees.getList(page, {
                search: state.search,
                searchBy: state.searchBy
            });
            if (page === 1) {
                await commit("setInitialPageCount", response.data);
            }
            commit("setPage", page);
            commit("getList", response);
            commit("pagination", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    create: async ({ commit }, payload) => {
        commit("loading");
        try {
            let response = await employees.create(payload);
            commit("created", response);
            notification.success(response.message);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    view: async ({ commit }, uuid) => {
        try {
            let response = await employees.view(uuid);
            commit("view", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    update: async ({ commit }, payload) => {
        try {
            const response = await employees.update(payload);

            commit("updated", response);
            notification.success(response.message);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    delete: async ({ commit }, uuid) => {
        try {
            let response = await employees.delete(uuid);
            commit("deleted", response);
            notification.success(response.message);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async nextPage({ commit }) {
        commit("loading");
    },

    async prevPage({ commit }) {
        commit("loading");
    },

    bulkImportEmployees: async ({ commit }, payload) => {
        commit("saving", true);
        try {
            const { message } = await employees.bulkImportEmployees(payload);
            notification.success(message);
        } catch (errors) {
            notification.warning("File uploaded is invalid");
            commit("errors", errors.errors);
        } finally {
            commit("saving", false);
        }
    },

    updateMmaAutoLogoutSettings: async ({ commit }, payload) => {
      commit("saving", true);
      commit("errors", {});

      try {
        await employees.updateMmaAutoLogoutSettings(payload);

      } catch (errors) {
        commit("errors", errors.errors);
      } finally {
        commit("saving", false);
      }
    },

    getMmaAutoLogoutSettings: async ({ commit }) => {
      commit("loading", true);
      commit("errors", {});

      try {
        const { data } = await employees.getMmaAutoLogoutSettings();
        commit("setMmaAutoLogoutSettings", data);
      } catch (errors) {
        commit("errors", errors.errors);
      } finally {
        commit("loading", false);
      }
    }
};

const getters = {
    saving: (state) => state.saving,
    loading: (state) => state.loading,
    errors: (state) => state.errors,
};

export default {
    namespaced: true,
    state: {
        created: false,
        updated: false,
        deleted: false,
        loading: false,
        list: [],
        view: {},
        page: 1,
        nextPage: false,
        prevPage: false,
        maxPage: false,
        error: null,
        errors: {},
        search: null,
        searchBy: "all",
        saving: false,
        mma_auto_logout_settings: null,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        }
    },
    mutations,
    actions,
    getters
};
